import React, {memo} from "react";

export const IconRemove = memo(({color}) => {
  return (
    <svg
      width="25"
      height="20"
      viewBox="0 0 25 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.92849 2.92893C-0.97474 6.83216 -0.97474 13.1678 2.92849 17.0711C6.83172 20.9743 13.1674 20.9743 17.0706 17.0711C20.9739 13.1678 20.9739 6.83216 17.0706 2.92893C13.1674 -0.974297 6.83172 -0.974297 2.92849 2.92893ZM14.2422 7.17157L11.4138 10L14.2422 12.8284L12.828 14.2426L9.99956 11.4142L7.17113 14.2426L5.75692 12.8284L8.58534 10L5.75692 7.17157L7.17113 5.75736L9.99956 8.58579L12.828 5.75736L14.2422 7.17157Z"
        fill={color || "#BA2E2E"}
      />
    </svg>
  );
});
